import { render, staticRenderFns } from "./CompanyAttributesForm.vue?vue&type=template&id=1aa87a44&"
import script from "./CompanyAttributesForm.vue?vue&type=script&lang=js&"
export * from "./CompanyAttributesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aa87a44')) {
      api.createRecord('1aa87a44', component.options)
    } else {
      api.reload('1aa87a44', component.options)
    }
    module.hot.accept("./CompanyAttributesForm.vue?vue&type=template&id=1aa87a44&", function () {
      api.rerender('1aa87a44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Companies/Forms/CompanyAttributesForm.vue"
export default component.exports